import o from "classnames";
const s = (t, r, a) => r && (a == null ? void 0 : a.length) !== 0 ? (console.warn("Data Grid: checkbox selection is not compatible with column selection"), "") : a != null && a.includes(t) ? "pl-data-grid-selected-column" : "", c = (t, r, a) => a && a({ data: t, rowData: r }) ? "pl-data-grid-invalid-cell" : "", f = (t, r, a, e) => ({
  /**
   * Generates the class name for a table header based on the column ID.
   *
   * @param {HeaderClassParams<RowType, unknown>} params - Parameters for the header class generator.
   * @returns {string} - The generated class name for the header.
   */
  headerClass: (l) => {
    var i;
    return s(
      (i = l.column) == null ? void 0 : i.getColDef().field,
      t,
      r
    );
  },
  /**
   * Generates the class name for a table cell based on the column ID.
   *
   * @param {CellClassParams<RowType, unknown>} params - Parameters for the cell class generator.
   * @returns {string} - The generated class name for the cell.
   */
  cellClass: (l) => {
    var i, n;
    return o(
      s(
        (i = l.column) == null ? void 0 : i.getColDef().field,
        t,
        r
      ),
      c(
        (n = l.data) == null ? void 0 : n[e],
        l.data,
        a
      )
    );
  }
});
export {
  s as getClassNameForSelectedColumn,
  f as getClassNamesForCellsAndHeaders
};
//# sourceMappingURL=index.es2345.js.map
